import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'unknown'
})
export class UnknownPipe implements PipeTransform {

  transform(value: unknown, replacementValue: string = 'Unknown'): string {
    // if (!!!value) {
    //   return replacementValue;
    // }

    if (value === null || value === undefined) {
      return replacementValue;
    }

    return `${value}`.length < 1 ? replacementValue : `${value}`;
  }

}
